import ComparisonMember from './ComparisonMember.vue'
import ComparisonResults from './ComparisonResults.vue'
import ComparisonResultsRow from './ComparisonResultsRow.vue'
import ComparisonResultsRowMemberVote from './ComparisonResultsRowMemberVote.vue'

const comparisonComponents = [ComparisonMember, ComparisonResults, ComparisonResultsRow, ComparisonResultsRowMemberVote]

export default comparisonComponents
